import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { logger } from '@/services/logger'
import { type EmployeeType, getEmployee, EMPLOYEE_PERMISSIONS } from '@/services/employees'
import { COLLABORATOR_STATUS } from '@/constants/collaborator'

export const useEmployeeStore = defineStore('employee', () => {
  const employee = ref<EmployeeType>()
  const setEmployeePendingPromise = ref<Promise<void> | null>(null)

  const setEmployee = async () => {
    if (setEmployeePendingPromise.value) {
      await setEmployeePendingPromise.value

      return
    }

    const promise = executeSetEmployee()
    setEmployeePendingPromise.value = promise
    await promise
  }

  const executeSetEmployee = async () => {
    try {
      const { data } = await getEmployee()

      employee.value = data
    } catch (error) {
      logger.error(error)

      throw error
    } finally {
      setEmployeePendingPromise.value = null
    }
  }

  const isAdmin = computed(
    () => employee.value?.authorization.role === COLLABORATOR_STATUS.ADMINISTRATOR
  )

  const hasAcceptedTerms = computed(
    () => employee.value?.compliance.termsAndConditions.isAccepted ?? false
  )

  const isAuthorizedForAab = computed(() =>
    employee.value?.authorization.permissions?.includes(
      EMPLOYEE_PERMISSIONS.AAB_COMPANY_PORTAL_READ
    )
  )

  return {
    employee,
    isAdmin,
    hasAcceptedTerms,
    isAuthorizedForAab,
    setEmployee
  }
})
